import {
  CustomerLogo,
  ProviderLogo,
} from "@lib/components/MiniComponents/Others";
import { Customer, Manager, Provider } from "@lib/types";
import { AvatarSize } from "@lib/types/General";
import { AppAvatar } from "..";

type AppUserLogoProps = {
  provider?: Provider;
  customer?: Customer;
  manager?: Manager;
  size?: AvatarSize;
};

export default function AppUserLogo(props: AppUserLogoProps) {
  const { provider, customer, manager, size = "medium" } = props;

  if (provider) return <ProviderLogo provider={provider} size={size} />;
  if (customer) return <CustomerLogo customer={customer} size={size} />;

  const managerName = `${manager?.firstName} ${manager?.lastName}`;

  return (
    <AppAvatar
      size={size as any}
      children={
        <>
          {managerName
            .split(" ")
            .map((name) => name[0])
            .join("")}
        </>
      }
    />
  );
}
